export * from './ProductsAiSearchDetectModalButton.types';
export { default as ProductsAiSearchDetectModalButton } from './ProductsAiSearchDetectModalButton';
